module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8eiihG/tc-custom/9781638295969.jpg?1705766123479",
      "alt": "This image is the cover for the book Leaving Patriarchy Behind"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Leaving Patriarchy Behind\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Can we fight, and win, against an ideology that has been established and practiced for decades? In "), _c('em', [_vm._v("Leaving Patriarchy Behind")]), _vm._v(", Leticia recounts her father’s disappointment at the birth of each daughter: “After each birth, Papa would turn to Mama and ask, ‘Mama, es un niño?’ But, out of 18 babies, Mama only had four boys.” With some challenging years behind her, Leticia considers the culture that informed her parents’ principles, those she knew she could not accept as her own. She realized from childhood that she was not one to follow the disparate rules set for boys and girls.")]), _c('p', [_vm._v("In these short vignettes, Leticia Aguilar recalls her life as a child in Mexico in the 1960s and as an adult in America in the ‘70s and beyond. Looking back, she reflects on her struggles as a girl, then a young woman, and the men who told her what she could and could not do. Instead, Leticia turned away from Mexican patriarchy, even as she was criticized and warned of her shortcomings in being independent. In a small mountain community in California where Leticia raised her family, she joined a variety of local organizations where she provided young women with a career, education, and family resources. Leticia’s memoir inspires others to rise above misogyny and racism.")]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif"
    }
  })]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Leticia Aguilar\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0